"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dot = void 0;
const styles_1 = require("@mui/material/styles");
const blink = (0, styles_1.keyframes) `
  0% {
    opacity: 0.25;
    transform: scale(1, 1);

  }

  50% {
    opacity: 1;
    transform: scale(1.5, 1.5);

  }

  100% {
    opacity: 0.25;
    transform: scale(1, 1);

  }

`;
exports.Dot = (0, styles_1.styled)("div")(({ theme }) => ({
    animationName: blink,
    display: "inline-block",
    animationDuration: "1.5s",
    animationIterationCount: "infinite",
    animationTimingFunction: "ease-in-out",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: theme.palette.institutional.braskemGray,
    marginLeft: "8px",
    "&:nth-of-type(2)": {
        animationDelay: "0.5s",
    },
    "&:nth-of-type(3)": {
        animationDelay: "1s",
    },
}));
